// Monotone cubic tangents — same algorithm as d3-shape curveMonotoneX (used by ApexCharts).

function sign(value) {
  return value < 0 ? -1 : 1
}

function slope3(x0, y0, x1, y1, x2, y2) {
  const h0 = x1 - x0
  const h1 = x2 - x1
  const s0 = (y1 - y0) / (h0 || (h1 < 0 && -0))
  const s1 = (y2 - y1) / (h1 || (h0 < 0 && -0))
  const blended = (s0 * h1 + s1 * h0) / (h0 + h1)

  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(blended)) || 0
}

function slope2(x0, y0, x1, y1, tangent) {
  const span = x1 - x0
  return span ? (3 * (y1 - y0) / span - tangent) / 2 : tangent
}

export function monotoneTangents(points) {
  const count = points.length
  const tangents = new Array(count).fill(0)
  if (count < 2) return tangents

  for (let index = 1; index < count - 1; index += 1) {
    tangents[index] = slope3(
      points[index - 1].x,
      points[index - 1].y,
      points[index].x,
      points[index].y,
      points[index + 1].x,
      points[index + 1].y
    )
  }

  const firstSlope = (points[1].y - points[0].y) / ((points[1].x - points[0].x) || 1)
  tangents[0] = slope2(points[0].x, points[0].y, points[1].x, points[1].y, firstSlope)

  tangents[count - 1] = slope2(
    points[count - 2].x,
    points[count - 2].y,
    points[count - 1].x,
    points[count - 1].y,
    tangents[count - 2]
  )

  return tangents
}

// SVG path for one monotone cubic segment (same control-point layout as d3/ApexCharts).
export function monotoneCubicSegmentPath(points, endIndex) {
  if (endIndex < 1 || endIndex >= points.length) return null

  const start = points[endIndex - 1]
  const end = points[endIndex]

  if (endIndex === 1) {
    return `M ${start.x} ${start.y} L ${end.x} ${end.y}`
  }

  const before = points[endIndex - 2]
  const tangents = monotoneTangents(points)
  const spanX = end.x - before.x
  const spanY = end.y - before.y

  const cp1x = start.x + tangents[endIndex - 1] * spanX / 6
  const cp1y = start.y + tangents[endIndex - 1] * spanY / 6
  const cp2x = end.x - tangents[endIndex] * spanX / 6
  const cp2y = end.y - tangents[endIndex] * spanY / 6

  return `M ${start.x} ${start.y} C ${cp1x} ${cp1y}, ${cp2x} ${cp2y}, ${end.x} ${end.y}`
}
